/* globals lp, jui */
var _ = require('lodash');

var defaultOptions = {
  hasRadiusControl: true,
};

lp.editor.panel = lp.editor.panel || {};
lp.editor.panel.ElementBorderControls = {
  /* Methods required in implementing object: */
  /* backgroundControlChanged */

  installBorderControls: function(options0) {
    var options = _.merge({}, defaultOptions, options0);

    this._borderUIBinding = this._uiBinding.mkNamespacedVersion('border');

    options.insert = options.insert || this.insert.bind(this);

    options.radiusChange = options.radiusChange || this.applyRadiusChange.bind(this);

    //TODO: update to rxUi when requestFocus doesn't require an object
    options.focus = options.focus || this.requestFocus.bind(this);

    this.adjustingCornerRadius = false;
    var self = this;

    this._borderUIBinding.subscribe(function(ev){

      if(ev.type === 'setBorderRadius')  {
        self.applyRadiusChange(ev);
      } if(ev.type === 'makeCircular') {
        self._makeCircular(ev.value);
      } else {
        self.updatingModel = true;
        //TODO: wrap this callback for rxUi
        self.borderControlsChanged(ev);
        self.updatingModel = false;
      }

    });

    var mkChangeHandler = function(type, valueName) {
      var changeHandler = function(ev0) {
        var ev = {};

        ev.type       = type;
        ev.elementId  = self.element.id;
        // so we can pass a useful name for this handler
        ev[valueName] = ev0.source.getValue();

        return self._borderUIBinding.onNext(ev);
      };
      return changeHandler;
    };

    this.controls.border = options.insert(new jui.FormBorderInput({
      onblur: mkChangeHandler('setBorderStyle', 'styles'),
      onfocus: options.focus
    }));

    this.controls.location = options.insert(new jui.FormSelect({
      label:'Location',
      width: '120px',
      id: 'jui-border-location-select',
      dropDownClassName : 'editor-info-panel-select jui-drop-down',
      selectOptions:[{name:'Inside',value:'inside'}, {name:'Outside',value:'outside'}],
      action: mkChangeHandler('setBorderLocation', 'borderLocation')
    }));

    this.controls.apply = options.insert(new jui.FormMultiCheckboxInput({
      label:'Apply to',
      checkboxes:[
        {id:'top'    , label:'Top:'    , checked:true},
        {id:'right'  , label:'Right:'  , checked:true},
        {id:'bottom' , label:'Bottom:' , checked:true},
        {id:'left'   , label:'Left:'   , checked:true}
      ],
      change: mkChangeHandler('setBorderApply', 'borderApply')
    }));

    this.installRadiusControls(options);

    this.modelChangeHandlers.push(function(e) {
      var accessor = e.data.accessor;
      var value = e.data.value;
      var m = e.source;

      switch(accessor) {
      case 'geometry.borderApply':
        self.controls.apply.setValue(value);
        break;
      case 'style.border':
        self.controls.border.setValue(value ? value : null);
        break;
      case 'geometry.borderLocation':
        self.controls.location.setSelectedValue(value);
        break;
      case 'geometry.cornerRadius':
        if (! this.adjustingCornerRadius) {
          self.setRadiusSliders(m);
        }
        break;
      case 'geometry.keepCircular':
        self.controls.keepCircular.setValue(value);
        break;
      }
    });
  },

  installRadiusControls: function(options) {
    var self = this;
    var radiusControls = new jui.Component();
    radiusControls.addClassName('border-radius-controls');
    radiusControls.e.style.cssText = '';
    radiusControls.setVisible(options.hasRadiusControl);

    options.insert(radiusControls);
    var radiusSeparateControls = new jui.Component();
    radiusSeparateControls.e.style.position = '';
    radiusControls.insert(radiusSeparateControls);

    this.controls.radius = {};

    var stopTracking = function() {
      self.element.page.undoManager.endGroup();
    };

    var startTracking = function() {
      self.element.page.undoManager.startGroup();
    };

    var sliderOptions = {
      min:0,
      max:100,
      allowOutOfRangeMaxValues:true,
      increment:1
    };


    var mkRadiusChange = function(corner) {
      var radiusChange = function(e) {
        self._borderUIBinding.onNext({
          type         : 'setBorderRadius',
          singleCorner : self.controls.radiusExpand.isSelected(),
          corner       : corner,
          radius       : e.data,
          elementId    : self.element.id
        });
      };
      return radiusChange;
    };

    var circularChange = function(e) {
      self._borderUIBinding.onNext({
        type: 'makeCircular',
        value: e.data,
        elementId: self.element.id
      });
    };

    var mkFocusChange = function() {
      var focusChange = function focusChange(e) {self.requestFocus(e);};
      return focusChange;
    };

    this.controls.radius.tl = radiusControls.insert(new jui.FormSliderInput({
      label:'Corner Radius',
      onchange: mkRadiusChange('tl'),
      onfocus: mkFocusChange(),
      startTracking: startTracking,
      stopTracking: stopTracking,
      slider:sliderOptions
    }));

    this.controls.radius.tr = radiusControls.insert(new jui.FormSliderInput({
      label: '',
      onchange: mkRadiusChange('tr'),
      onfocus: mkFocusChange(),
      startTracking: startTracking,
      stopTracking: stopTracking,
      slider:sliderOptions
    }));

    this.controls.radius.bl = radiusControls.insert(new jui.FormSliderInput({
      label: '',
      onchange: mkRadiusChange('bl'),
      onfocus: mkFocusChange(),
      startTracking: startTracking,
      stopTracking: stopTracking,
      slider:sliderOptions
    }));

    this.controls.radius.br = radiusControls.insert(new jui.FormSliderInput({
      label: '',
      onchange: mkRadiusChange('br'),
      onfocus: mkFocusChange(),
      startTracking: startTracking,
      stopTracking: stopTracking,
      slider:sliderOptions
    }));

    this.controls.radiusExpand = new jui.IconToggle('expander', {
      classNames:['radius', 'corner-radius-icon'],
      action: function(e) {
        self.setCornerControlsVisibility(e.data);
        if (! e.data) {
          self.resetRadius();
        } else {
          var r = self.controls.radius.tl.getValue();
          self.controls.radius.tr.setValue(r);
          self.controls.radius.bl.setValue(r);
          self.controls.radius.br.setValue(r);
        }
      }
    });


    var cornerRadiusSVG = ['<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27 27" xml:space="preserve">',
      '<path class="radius-tr" d="M24,0h-7.4c-0.5,0-0.9,0.4-0.9,0.9v2.6c0,0.5,0.4,0.9,0.9,0.9h4.7c0.7,0,1.3,0.6,1.3,1.3v4.7 c0,0.5,0.4,0.9,0.9,0.9h2.6c0.5,0,0.9-0.4,0.9-0.9V3C27,1.3,25.7,0,24,0"/>',
      '<path class="radius-br" d="M26.1,15.8h-2.6c-0.5,0-0.9,0.4-0.9,0.9v4.7c0,0.7-0.6,1.3-1.3,1.3h-4.7c-0.5,0-0.9,0.4-0.9,0.9v2.6 c0,0.5,0.4,0.9,0.9,0.9H24c1.6,0,3-1.3,3-3v-7.4C27,16.2,26.6,15.8,26.1,15.8"/>',
      '<path class="radius-bl" d="M10.3,22.7H5.6c-0.7,0-1.3-0.6-1.3-1.3v-4.7c0-0.5-0.4-0.9-0.9-0.9H0.9c-0.5,0-0.9,0.4-0.9,0.9V24 c0,1.6,1.3,3,3,3h7.4c0.5,0,0.9-0.4,0.9-0.9v-2.6C11.2,23.1,10.8,22.7,10.3,22.7"/>',
      '<path class="radius-tl" d="M11.2,0.9v2.6c0,0.5-0.4,0.9-0.9,0.9H5.6c-0.7,0-1.3,0.6-1.3,1.3v4.7c0,0.5-0.4,0.9-0.9,0.9H0.9 c-0.5,0-0.9-0.4-0.9-0.9V3c0-1.6,1.3-3,3-3h7.4C10.8,0,11.2,0.4,11.2,0.9"/>',
      '<path class="radius-cross-horz" d="M8.6,12.6C8,12.6,8,13,8,13.5s0,0.9,0.6,0.9h9.9c0.5,0,0.6-0.4,0.6-0.9s0-0.9-0.6-0.9H8.6z"/>',
      '<path class="radius-cross-vert" d="M14.4,8.6C14.4,8,14,8,13.5,8s-0.9,0-0.9,0.6l0,9.9c0,0.5,0.4,0.6,0.9,0.6s0.9,0,0.9-0.6L14.4,8.6z"/>',
      '</svg>'
    ].join();

    this.controls.radius.tl.slider.insert(this.controls.radiusExpand.update(cornerRadiusSVG));

    this.controls.radius.tr.slider.insert(new Element('div', {className:'icon corner tr corner-radius-icon'}).update(cornerRadiusSVG));
    this.controls.radius.bl.slider.insert(new Element('div', {className:'icon corner bl corner-radius-icon'}).update(cornerRadiusSVG));
    this.controls.radius.br.slider.insert(new Element('div', {className:'icon corner br corner-radius-icon'}).update(cornerRadiusSVG));

    this.controls.keepCircular = radiusControls.insert(new jui.FormCheckboxInput({
      label: 'Ensure maximum curvature!',
      attributes: {
        'class': 'form-elm checkbox-input max-curvature-checkbox'
      },
      inputId: 'keep-circular-checkbox',
      onclick: circularChange
    }));

    this.controls.radiusContainer = radiusControls;
  },

  // TODO: split into the discreet properties
  borderControlsChanged: function(ev) {
    var undoManager = this.element.page.undoManager;

    undoManager.startGroup();
    if(ev.styles) {
      this.element.model.set('style.border', ev.styles, undoManager);
    }

    if(ev.borderLocation) {
      this.element.model.set('geometry.borderLocation', ev.borderLocation, undoManager);
    }

    if(ev.borderApply) {
      this.element.model.set('geometry.borderApply', ev.borderApply, undoManager);
    }
    undoManager.endGroup();
  },

  _makeCircular: function(value) {
    this.element.model.keepCircular(value, this.element.page.undoManager);
  },

  applyRadiusChange: function(ev) {
    var m = this.element.model;
    var um = this.element.page.undoManager;

    if(ev.singleCorner) {
      var radius = {};
      radius[ev.corner] = ev.radius;
      m.setCornerRadius(radius, um);
    } else {
      m.setCornerRadius(ev.radius, um);
    }
  },

  checkIfKeepCircular: function() {
    var m = this.element.model;
    if (m.isKeepCircular()) {
      m.makeCircular();
    }
  },

  resetRadius: function() {
    if(this.controls.radius) {
      var um = this.element.page.undoManager;
      var m = this.element.model;
      var cr = this.controls.radius.tl.getValue();
      m.setCornerRadius(cr, um);
      this.controls.radius.tr.setValue(cr);
      this.controls.radius.bl.setValue(cr);
      this.controls.radius.br.setValue(cr);
    }
  },

  setCornerControlsVisibility: function(isVisible) {
    if(this.controls.radius) {
      this.controls.radius.tr.setVisible(isVisible);
      this.controls.radius.bl.setVisible(isVisible);
      this.controls.radius.br.setVisible(isVisible);
      this.isVisible = isVisible;
    }
  },

  setRadiusSliders: function(m) {
    if(this.controls.radius) {
      var radius = m.exists('geometry.cornerRadius') ? m.get('geometry.cornerRadius') : 0;

      if (Object.isNumber(radius)) {
        var isVisible = Boolean(this.isVisible);
        this.controls.radius.tl.setValue(radius);
        this.controls.radius.tr.setValue(radius);
        this.controls.radius.bl.setValue(radius);
        this.controls.radius.br.setValue(radius);
        this.setCornerControlsVisibility(isVisible);
        this.controls.radiusExpand['toggle' + (isVisible ? 'On' : 'Off')]();
      } else {
        this.controls.radius.tl.setValue(radius.tl);
        this.controls.radius.tr.setValue(radius.tr);
        this.controls.radius.bl.setValue(radius.bl);
        this.controls.radius.br.setValue(radius.br);
        this.setCornerControlsVisibility(true);
        this.controls.radiusExpand.toggleOn();
      }

    }
  },

  bindBorderControlsToElement: function(elm) {
    var m = elm.model;
    this.controls.border.setValue(m.exists('style.border') ? m.get('style.border') : null);
    this.controls.location.setSelectedValue(m.get('geometry.borderLocation'));
    if (this.controls.keepCircular) {
      this.controls.keepCircular.setValue(m.isKeepCircular());
    }
    if (m.exists('geometry.borderApply')) {
      this.controls.apply.setValue(m.get('geometry.borderApply'));
    } else {
      this.controls.apply.setValue({top:true, right:true, bottom: true, left:true});
    }
    this.isVisible = false;
    this.setRadiusSliders(m);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/panel/element_border_controls.js
// module id = 1038
// module chunks = 0